import { css } from '@emotion/react';

const disclaimerStyles = css``;

export default disclaimerStyles;
